export default __webpack_public_path__ + "static/media/black-layers-icon.7ea940e7.svg";